import * as React from "react";

import { Button } from "@replohq/lattice/components/button/Button";
import { cn } from "@replohq/lattice/utils/cn";
import { Minus, Plus } from "lucide-react";

type QuantityControlProps = {
  value: number;
  onIncrement: () => void;
  onDecrement: () => void;
  label: React.ReactNode;
  minValue?: number;
  maxValue?: number;
  centered?: boolean;
  hideControls?: boolean;
};

const QuantityControl: React.FC<QuantityControlProps> = ({
  value,
  onIncrement,
  onDecrement,
  label,
  minValue = 0,
  maxValue,
  centered = false,
  hideControls = false,
}) => {
  return (
    <div className="flex w-full items-center gap-3 text-default">
      <span className={cn("flex-1 text-sm", centered && "text-center")}>
        {label}
      </span>

      <div
        className={cn("flex items-center gap-3", hideControls && "invisible")}
      >
        <Button
          icon
          variant="secondary"
          size="base"
          aria-label="Decrease quantity"
          onClick={onDecrement}
          disabled={value <= minValue}
        >
          <Minus />
        </Button>
        <Button
          icon
          variant="secondary"
          size="base"
          aria-label="Increase quantity"
          onClick={onIncrement}
          disabled={value >= (maxValue ?? Number.POSITIVE_INFINITY)}
        >
          <Plus />
        </Button>
      </div>
    </div>
  );
};

export default QuantityControl;
